import { GasSearchTabsProps } from "../../types/components.types";

// The component below renders the 'MPRN' and 'Address' tab buttons.
// It uses the 'activeTab' prop to determine which tab is currently selected.
// onTabChange updates the activeTab when a user clicks on a specific tab.
// The Address tab is only rendered if the user is an admin member (AdminManager or AdminMember from AWS Cognito user groups).
const SearchTabs: React.FC<GasSearchTabsProps> = ({ activeTab, onTabChange, isAdmin }) => {
  return (
    <div className="search-tabs">
      <button
        // If 'activeTab' is 'mprn', add the 'active' class to highlight the selected tab.
        className={`tab-button ${activeTab === "mprn" ? "active" : ""}`}
        // Call the 'onTabChange' with 'mprn' to update the active tab.
        onClick={() => {
          onTabChange("mprn");
        }}
      >
        MPRN
      </button>

      {/* Only render the Address tab button if the user is an admin member. */}
      {isAdmin && (
        <button
          // If 'activeTab' is 'address', add the 'active' class to highlight the selected tab.
          className={`tab-button ${activeTab === "address" ? "active" : ""}`}
          // Call the 'onTabChange' with 'address' to update the active tab.
          onClick={() => {
            onTabChange("address");
          }}
        >
          Address
        </button>
      )}
    </div>
  );
};

export default SearchTabs;
